import { Transitions } from "../../../common/components/Transitions";
import { useEffect, useState } from "react";
import InformativeCard from "../components/InformativeCard";
import { AssessmentShell } from "../components/AssessmentShell";
import PracticeVideo from "../components/PracticeVideo";
import { useNavigate } from "react-router";
import { NavItems } from "../../../common/helpers/navigation";
import { sleepFor } from "../../../common/helpers/countHelper";
import { useAppSelector } from "../../../app/hooks";
import { getInstructionFromStep } from "../../../common/helpers/instructionHelper";

const WELCOME = "Welcome";

export const AssessmentPracticeInstruction = (): JSX.Element => {
    const [showDuration, setShowDuration] = useState(false);
    const [errorLoadingVideo, setErrorLoadingVideo] = useState(false);

    const navigate = useNavigate();

    const welcomeInstruction = useAppSelector((x) => getInstructionFromStep(x.assessmentForm.instructions, WELCOME));

    const [currentCaption, setCurrentCaption] = useState("");

    // TODO: handle CC from ccType as a handler that changes currentCaption
    useEffect(() => {
        if (errorLoadingVideo) {
            const instructions = welcomeInstruction.instructionText.split(";");

            instructions.forEach((instruction, index) => {
                setTimeout(() => {
                    setCurrentCaption(instruction);
                }, index * 3 * 1000);
            });

            // before last show informative card
            setTimeout(() => {
                setShowDuration(true);
            }, (instructions.length - 1) * 3 * 1000);

            setTimeout(() => {
                void handleOnEnd();
            }, (instructions.length + 1) * 3 * 1000);
        }
    }, [errorLoadingVideo]);

    const handleOnVideoError = (): void => {
        setErrorLoadingVideo(true);
    };

    const handleOnEnd = async (): Promise<void> => {
        await sleepFor(3);

        navigate(NavItems.Assessments.DeviceCheckInstruction.path);
    };

    return (
        <AssessmentShell>
            {errorLoadingVideo && (
                <div className="columns">
                    {showDuration && (
                        <>
                            <InformativeCard shouldOverlay left />
                            <div className="column is-4" />
                        </>
                    )}
                    <div className="column">
                        <Transitions currentCaption={currentCaption} />
                    </div>
                </div>
            )}
            {!errorLoadingVideo && (
                <PracticeVideo
                    url={welcomeInstruction.instructionVideoUrl}
                    onLoadError={handleOnVideoError}
                    onEnd={handleOnEnd}
                />
            )}
        </AssessmentShell>
    );
};
